import { Box, Button, Card, CardHeader, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { BaseKey } from "@refinedev/core";
import type { ListProps } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import { config } from "config";
import React, { useState } from "react";
import { dataProvider } from "rest-data-provider";

type ExtendedListProps = ListProps & {
  uuid: BaseKey | undefined
};

export const PasswordList: React.FC<ExtendedListProps> = ({
  wrapperProps,
  uuid,
}) => {
  const {
    formState: { errors },
    setError,
    clearErrors,
  } = useForm();
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState('')
const handleClickOpen = () => {
    setOpen(true);
  };
  const apiUrl = config().server.api;

  const handleSave = () => {
    dataProvider(apiUrl).update({
      resource: "v2/admin/user/account",
      id: uuid ?? '',
      variables: {
        admin: true,
        authority: {},
        password: password,
      },
    }).then(()=>{
      alert("Update password success!")
    })
    setOpen(false);
  };
  const handleClose = () => {
    setOpen(false);
  };


  return (
    <Card {...(wrapperProps ?? {})}>
      <CardHeader
        sx={{ display: "flex", flexWrap: "wrap" }}
        color="blue"
        title="Password Info"
        action={
          <Box display="flex" gap="16px">
            <Button variant="outlined" onClick={handleClickOpen}>
              Modify Password
            </Button>
          </Box>
        }
      />
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Add</DialogTitle>
        <DialogContent>
          <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          error={!!errors.password}
          helperText={(errors as any)?.password?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="password"
          label="Password"
          name="password"
          onChange={(e)=>{
            if(!/^\w{8,}$/.test(e.target.value) && e.target.value !== ''){
                setError('password', { type: 'custom', message: 'Input at least 8 characters of alphabetas, numbers or underscores' });
            }
            else {
                clearErrors('password');
            }
            setPassword(e.target.value)
          }}
        />
        <TextField
          error={!!errors.password_confirmation}
          helperText="Password confirmation should match password"
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="password"
          label="Password Confirmation"
          name="password_confirmation"
          onChange={(e)=>{
            if(e.target.value !== password && e.target.value !== ''){
                setError('password_confirmation', { type: 'custom', message: 'Password confirmation does not match password' });
            }
            else {
                clearErrors('password_confirmation');
            }
          }}
        />
      </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave}>Save</Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};
